export const AFTER_AUTH_REDIRECT_COOKIE = "afterAuthRedirect";
